<div class="loader" [style.padding]="padding" [style.height]="height">
  <mat-spinner
    [diameter]="diameter"
    strokeWidth="2"
    color="primary"
    mode="indeterminate"></mat-spinner>
</div>
